import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '🔍',
    subtitle: 'Diagnóstico y Carga: El Semáforo del Dolor',
    desc: 'Entendé qué le pasa a tu cuerpo antes de que la lesión te detenga. El Protocolo de Carga Selectiva y el Semáforo del Dolor para ajustar cada sesión a lo que tu cuerpo puede tolerar ese día.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '⏱️',
    subtitle: 'Estructura Sub-60: Rendimiento en Tiempo Récord',
    desc: 'Microciclos para corredores con vida real. 3 días de alta calidad por semana, identificación de tu ritmo de umbral y más adaptación en 45 minutos que otros en 90 de trote monótono.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }, {
    icon: '🦵',
    subtitle: 'Biomecánica Anti-Impacto: Correr sin Frenos',
    desc: 'Eliminá el dolor articular y convertí cada zancada en propulsión real. Cadencia, mediopié, postura axial y braceo. Incluye protocolo de autograbación con tu celular.',
    color: 'from-[#16a34a]/10 to-transparent',
    border: 'border-t-[#16a34a]'
  }, {
    icon: '🥗',
    subtitle: 'Nutrición y Recobro: El Combustible del Rendimiento',
    desc: 'Estrategia de nutrición antes, durante y después de correr con presupuesto e ingredientes argentinos. Evitá el muro metabólico y usá el sueño como herramienta de recuperación.',
    color: 'from-[#15803d]/10 to-transparent',
    border: 'border-t-[#15803d]'
  }, {
    icon: '💪',
    subtitle: 'Fuerza Blindada: La Armadura del Corredor',
    desc: '15 minutos de fuerza específica que vuelven indestructibles tus articulaciones. Glúteo medio, core anti-rotación, sóleo y propiocepción de tobillo. Sin gimnasio, dos veces por semana.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '📅',
    subtitle: 'El Plan Maestro: Cronograma y Ejecución Final',
    desc: 'El mapa anual que integra todo el sistema. Periodización por bloques perpetua, gestión del tapering pre-carrera y protocolo de reinicio después de pausas sin perder progreso.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-399">
      <FadeIn data-id="element-400">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-401">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-402">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-403">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-404">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-white border border-[#e2e8f0] ${tomo.border} border-t-4 hover:border-[#22c55e] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-405">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-406"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#16a34a] bg-[#f8fafc] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e2e8f0]" data-id="element-407">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-408">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-[#0f172a] mb-1.5 md:mb-2 relative z-10" data-id="element-409">
                {tomo.subtitle}
              </h3>

              <p className="text-sm md:text-base text-[#475569] font-medium leading-relaxed flex-grow relative z-10" data-id="element-410">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}